const CountryCardMain = ({ country, isHighlighted }) => {
  const { flags, name } = country;

  return (
    <div
      className={`group flex min-h-[88px] flex-col items-center justify-center gap-1.5 rounded-lg border px-2 py-2.5 transition-all duration-200 sm:min-h-[122px] sm:gap-2.5 sm:rounded-xl sm:p-4 ${
        isHighlighted
          ? 'border-brand-500/65 bg-gradient-to-b from-brand-900/35 to-slate-900/85 shadow-glow ring-1 ring-brand-500/30'
          : 'border-slate-700/50 bg-slate-900/40 hover:-translate-y-0.5 hover:border-slate-500/80 hover:bg-slate-900/75'
      }`}
    >
      <div className="rounded-md border border-slate-700/60 bg-slate-950/45 p-0.5 shadow-sm ring-1 ring-white/5 sm:rounded-lg sm:p-1.5">
        <img src={flags.svg} alt="" className="h-6 w-auto rounded-sm ring-1 ring-black/20 sm:h-9 sm:rounded-md" loading="lazy" />
      </div>
      <p className="line-clamp-2 text-center text-[10px] font-semibold leading-snug text-slate-100 sm:text-[13px]">{name.common}</p>
    </div>
  );
};

export default CountryCardMain;
